import ErrorStoreModule, { errorStore } from '@/store/errors/ErrorStoreModule'
import BasicStoreModule, { basicStore } from '@/store/basic/BasicStoreModule'

export interface IStoreAccess {
  errors: ErrorStoreModule
  basic: BasicStoreModule
}

export const StoreAccess = function(): IStoreAccess {
  return {
    errors: errorStore,
    basic: basicStore
  }
}

export default StoreAccess
